module.exports = __webpack_public_path__ + "prod/1.42.2/img/51job-icon.7402f29b.png";